import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { fetchImageToken } from "../../../../redux/actions/imageAuth";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import RestlessDisplayLarge from "../../../components/common/RestlessDisplayLarge";

export default function RestlessContentReviewDialog({ row, id, show, onHide, markContentAsReview}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchImageToken);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
  
              <Modal.Header>
                <div className="">Monitor {row.type}</div>
              </Modal.Header>
              <Modal.Body>
              <div className="col">
              <RestlessDisplayLarge
                label="Text"
                content={
                  row.review_notes || (
                    <div className="text-muted">This content has no review notes</div>
                  )
                }
              />
            </div>
              </Modal.Body>
              <Modal.Footer>
              <Button className="btn btn-secondary" onClick={onHide}>
                Cancel
              </Button>
            </Modal.Footer>
      </Modal>
    </>
  );
}
